import {
  WBList,
  WBListItem,
  WBListItemIcon,
  WBTypography,
} from '@admiin-com/ds-web';
import { WBListItemText } from '@admiin-com/ds-web';
import { WBS3Avatar } from '@admiin-com/ds-amplify-web';
import { WBFlex } from '@admiin-com/ds-web';
import { Entity } from '@admiin-com/ds-graphql';
export const TaxBindingHeader = ({
  entity,
  index,
  totalDocuments,
}: {
  entity: Entity;
  index: number;
  totalDocuments: number;
}) => {
  const subTitle = `Document ${index} / ${totalDocuments}`;
  return (
    <WBFlex justifyContent={'center'} alignItems={'center'} mb={1}>
      <WBList>
        <WBListItem
          sx={{
            alignItems: 'center',
            gap: [1, 2],
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <WBListItemIcon
            sx={{
              minWidth: 'auto',
            }}
          >
            {entity && (
              <WBS3Avatar
                sx={{
                  borderRadius: '50%',
                  width: { xs: '30px', md: '30px' },
                  height: { xs: '30px', md: '30px' },
                }}
                imgKey={entity.logo?.key}
                fontSize="h4.fontSize"
                identityId={entity.logo?.identityId}
                level={entity.logo?.level}
                companyName={entity.name}
              />
            )}
          </WBListItemIcon>
          <WBListItemText
            primary={
              <WBTypography
                textAlign="center"
                noWrap
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: { xs: '250px', sm: '100%' },
                }}
              >
                {entity?.name}
              </WBTypography>
            }
            secondary={
              subTitle && (
                <WBTypography variant="body2" color="textSecondary" noWrap>
                  {subTitle}
                </WBTypography>
              )
            }
          />
        </WBListItem>
      </WBList>
    </WBFlex>
  );
};
